export default `
<section class="bg-white first">
    <div class="href"><a href="++{{section6link}}">++{{section6linktext}}</a></div>
</section>
`

